import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import {
    Typography,
    Box,
    FormControlLabel,
    Checkbox,
} from "@material-ui/core";
import {ReactComponent as UnCheckedBox} from "../../../common/images/UnCheckedBox.svg";
import {ReactComponent as CheckedBox} from "../../../common/images/CheckedBox.svg";
import {inject, observer} from "mobx-react";
import {FormattedMessage, injectIntl} from "react-intl";
import {validateNumber} from "../../../common/Validation";

const style = theme => ({
    root: {},
    labelText: {
        fontFamily: 'NanumSquareRoundOTF',
        fontSize: '1.2rem',
        fontWeight: 600,
        color: '#000',
    },
    checkBox: {
        width: '100%',
        "& .MuiFormControlLabel-label": {
            fontFamily: 'NanumSquareRoundOTF',
            fontSize: '1.2rem',
            color: '#0d0d0d',
            // fontWeight: 600
        }
    },
    guestCheckText: {
        fontFamily: 'NanumSquareRoundOTF',
        fontSize: '1.2rem',
        color: '#333',
        fontWeight:600,
    },
    inputStyle1: {
        width: '100%',
        padding: 10,
        borderRadius: 5,
        background: '#f2f3f7',
        border: 0,
        fontFamily: 'NanumSquareRoundOTF',
        fontSize: '1.2rem',
        color: '#0d0d0d',
        margin: '10px 0 9px',
        "&::placeholder":{
            fontSize: '1.2rem',
        },
        "&:focus":{
            outline: 'none !important'
        }
    },
    textStyle: {
        fontFamily: 'NanumSquareRoundOTF',
        fontSize: '1rem',
        color: '#666666'
    },
});

@inject('roomStore')
@observer
class MobileGuestParticipation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            guestParticipation: false,
        }
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.didMountRoomInfo !== undefined) {
            if (this.props.didMountRoomInfo !== prevProps.didMountRoomInfo) {
                this.setState({guestParticipation: true})
            }
        }
    }

    componentWillUnmount() {
        this.setState({guestParticipation: false})
    }

    handleChecked = (e) => {
        this.setState({
            guestParticipation: e.target.checked,
        });
        this.props.roomStore.changeGuestNum("")
    };

    changeGuestNum = (event) => {
        let { value, min, max } = event.target;
        value = Math.max(Number(min), Math.min(Number(max), Number(value)));
        if(value === 0){
            value = ''
        }
        if (value <= this.props.roomStore.roomInfo.maxUsers || this.props.roomStore.roomInfo.maxUsers === 0) {
            this.props.roomStore.changeGuestNum(value)
        } else {
            this.props.roomStore.changeGuestNum("")
        }
    }

    isNotNumber = (value) => validateNumber(value);

    render() {
        const {classes, intl, roomStore} = this.props;
        return (
            <div>
                <Box pb={3}>
                    <Typography className={classes.labelText}><FormattedMessage id="guest"/></Typography>
                    <Box display='flex' flexDirection="column" className={classes.checkBox}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    icon={<UnCheckedBox/>}
                                    checkedIcon={<CheckedBox/>}
                                    checked={this.state.guestParticipation}
                                    onChange={this.handleChecked}
                                />
                            }
                            label={intl.formatMessage({id: "allow_guest"})}
                            style={{width: 200}}
                        />
                    </Box>
                </Box>
                {this.state.guestParticipation &&
                <Box style={{ width: '100%'}} pb={3}>
                    <Typography className={classes.guestCheckText}>
                        <FormattedMessage id="guest_number"/>
                        <span style={{color: '#ff0000', marginLeft: 5}}>*</span>
                    </Typography>

                    <input
                        name="Numbers"
                        type="text"
                        id="Numbers"
                        value={roomStore.roomInfo.guestNum}
                        placeholder={
                            roomStore.roomInfo.maxUsers > 0 ?
                                intl.formatMessage({id: "msg.insert_room_guest_number"})+ " ("+ intl.formatMessage({id: "max_user_count"}) + roomStore.roomInfo.maxUsers + intl.formatMessage({id: "person"})+")"
                                :
                                intl.formatMessage({id: "msg.insert_room_guest_number"})}
                        className={classes.inputStyle1}
                        onPaste={(e)=>{ e.preventDefault(); return false;}}
                        onChange={e => {
                            if (e.nativeEvent.data && this.isNotNumber(e.nativeEvent.data)) { e.preventDefault(); return null; }
                            this.changeGuestNum(e);
                        }}
                    />
                </Box>
                }
            </div>
        );
    }
}

export default withStyles(style)(injectIntl(MobileGuestParticipation));